import React from 'react';
import PropTypes from 'prop-types';
import ButtonShell from './ButtonShell';
import withPresets from '@xingternal/with-presets';
import * as skins from './skins';

const ButtonComposition = ({ children = undefined, ...props }) => {
  const iconOnly = !children;
  const PlainComponent = plainComponentProps => (
    <ButtonShell {...plainComponentProps}>{children}</ButtonShell>
  );
  const Component = withPresets(skins)(PlainComponent);
  return <Component iconOnly={iconOnly} {...props} />;
};

ButtonComposition.propTypes = {
  children: PropTypes.node,
};
export default ButtonComposition;
